import * as actions from "../action.constants";

const requestCustomers = (pageUrl, callback) => ({
  type: actions.REQUEST_GET_CUSTOMERS_LIST_SAGA,
  pageUrl,
  callback,
});

const saveCustomersList = (data) => ({
  type: actions.SAVE_GET_CUSTOMERS_LIST,
  payload: data,
});

const requestCustomersLabelValue = (pageUrl) => ({
  type: actions.GET_CUSTOMERS_LABEL_VALUE_LIST,
  pageUrl,
});

const saveCustomersLabelValue = (data) => ({
  type: actions.STORE_CUSTOMERS_LABEL_VALUE_LIST,
  payload: data,
});

const saveSelectedCustomer = (selectedCustomer) => {
  localStorage.setItem("customer", JSON.stringify(selectedCustomer));
  return {
    type: actions.SAVE_SELECTED_CUSTOMER,
    selectedCustomer,
  };
};

const sendCustomerModalData = (data, routeDetails, callback) => ({
  type: actions.REQUEST_SEND_CUSTOMER_DATA_SAGA,
  payload: data,
  routeDetails,
  callback,
});

export {
  requestCustomers,
  saveCustomersList,
  requestCustomersLabelValue,
  saveCustomersLabelValue,
  sendCustomerModalData,
  saveSelectedCustomer,
};
